import { createContext } from 'react';

export const ErrorsContext = createContext(null);
